import React from "react";

export default function App() {
  return (
    <div style={{ fontFamily: "Arial, sans-serif", padding: 24 }}>
      <h1>ПартАпарт</h1>
      <p>Edit <code>src/App.js</code> and refresh.</p>
    </div>
  );
}
